/* Tattoo Studio landing (sections/cz-landing.liquid): scroll reveal, jumps into the studio, videos that only play while
   visible (tap for sound, play button when the browser blocks autoplay), step animations, the finger-set Builder demo,
   the typed AI prompt and the rail arrows. Everything degrades to a static page without JS or with reduced motion. */
(function () {
  var sec = document.getElementById('czl');
  if (!sec || sec.__czl) return;
  sec.__czl = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  if (reduce || !hasIO) sec.classList.add('czl--still');

  function onView(el, cb, opts) {
    if (!hasIO) { cb(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting, e); }); }, opts || { threshold: 0.3 }).observe(el);
  }

  /* reveal on scroll (content stays visible without JS or with reduced motion) */
  if (!reduce && hasIO) {
    sec.classList.add('czl--anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; el.classList.add('is-in'); io.unobserve(el);
        setTimeout(function () { el.removeAttribute('data-czl-r'); el.classList.remove('is-in'); }, 1400);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    sec.querySelectorAll('[data-czl-r]').forEach(function (el) { io.observe(el); });
  }

  /* jumps into the studio: "Jetzt gestalten", size cards (select that size), AI card (open the AI tool), Builder */
  function toStudio(smooth) { window.scrollTo({ top: 0, behavior: smooth && !reduce ? 'smooth' : 'auto' }); }
  /* «Was das Studio kann»: three tabs (arrow keys move between them) */
  var can = sec.querySelector('[data-czl-can]');
  if (can) {
    var tabs = [].slice.call(can.querySelectorAll('[data-czl-tab]'));
    var pick = function (t, focus) {
      tabs.forEach(function (b) {
        var on = b === t, p = document.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; if (p) p.hidden = !on;
      });
      if (focus) t.focus();
    };
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { pick(b); });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (d) { e.preventDefault(); pick(tabs[(i + d + tabs.length) % tabs.length], true); }
      });
    });
  }

  sec.addEventListener('click', function (ev) {
    /* «Ausprobieren» on the skin tab: up into the studio, switch it to the skin view */
    var sk = ev.target.closest('[data-czl-skin]');
    if (sk) {
      ev.preventDefault(); toStudio(true);
      setTimeout(function () {
        var root = document.getElementById('czs');
        if (root && root.getAttribute('data-mode') !== 'skin') { var m = document.querySelector('.czs-mode [data-mode="skin"]') || document.querySelector('.czs-mode'); if (m) m.click(); }
      }, reduce ? 0 : 450);
      return;
    }
    var go = ev.target.closest('[data-czl-go]');
    if (go) {
      ev.preventDefault();
      var code = go.getAttribute('data-czl-size');
      if (code) { var sb = document.querySelector('.czs-size[data-size="' + code + '"]'); if (sb) sb.click(); }
      toStudio(true);
      var tool = go.getAttribute('data-czl-tool');
      if (tool) setTimeout(function () { var t = document.querySelector('#czs [data-tool="' + tool + '"]'); if (t) t.click(); }, reduce ? 0 : 450);
      return;
    }
    var bl = ev.target.closest('[data-czl-builder]');
    if (bl) {
      var btool = document.querySelector('#czs [data-tool="builder"]');
      if (!btool) return; /* studio not ready: the link reloads with ?builder=… */
      ev.preventDefault();
      toStudio(false);
      var kind = bl.getAttribute('data-czl-builder');
      if (kind) {
        var b = document.createElement('button');
        b.type = 'button'; b.hidden = true; b.setAttribute('data-act', kind);
        document.getElementById('czs').appendChild(b); b.click(); b.remove();
      } else btool.click();
    }
  });

  /* videos (hero + community reel): muted loop while visible; if autoplay is refused (iOS low-power mode, data saver)
     a play button appears; tapping a reel video plays it with sound and mutes the others */
  var vids = [].slice.call(sec.querySelectorAll('[data-czl-video] video'));
  var saveData = navigator.connection && navigator.connection.saveData;
  function tryPlay(v) {
    var item = v.closest('.czl-reel__item');
    /* hero: the mp4 is only set now (snippets/cz-hero-collage: data-lazy-src, smaller copy on phones, sharper one on 2x desktop screens) */
    if (!v.getAttribute('src') && v.dataset.lazySrc) {
      var phone = window.innerWidth < 990;
      v.src = (phone && v.dataset.lazySrcSd) || (!phone && (window.devicePixelRatio || 1) >= 1.5 && v.dataset.lazySrcHd) || v.dataset.lazySrc;
    }
    if (v.preload === 'none') v.preload = 'auto';
    var pr = v.play();
    if (pr && pr.then) pr.then(function () { if (item) item.classList.remove('is-blocked'); }).catch(function () { if (item) item.classList.add('is-blocked'); });
  }
  /* hero video: start only after its poster image is on screen, so the poster (LCP) loads first */
  function afterPoster(v, cb) {
    var im = v.parentNode.querySelector('.czl-hm__poster');
    var done = false;
    var go = function () { if (!done) { done = true; cb(); } };
    if (!im || (im.complete && im.naturalWidth)) { go(); return; }
    im.addEventListener('load', go, { once: true }); im.addEventListener('error', go, { once: true });
  }
  vids.forEach(function (v) {
    v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.loop = true; v.removeAttribute('controls');
    /* no autoplay with "reduce motion" or the data saver: the poster stays, a tap on a reel clip still plays it */
    if (reduce || saveData) { v.removeAttribute('autoplay'); v.pause(); return; }
    afterPoster(v, function () {
      /* visibility of the hero frame (the video itself sits 1 px inside it, see cz-landing.css), so the start point is unchanged */
      onView(v.closest('.czl-hm--video') || v, function (vis) { if (vis && !document.hidden) tryPlay(v); else v.pause(); }, { threshold: 0.35 });
    });
  });
  function setSound(item) {
    sec.querySelectorAll('.czl-reel__item.is-sound').forEach(function (o) {
      if (o === item) return;
      o.classList.remove('is-sound'); var ov = o.querySelector('video'); if (ov) ov.muted = true;
    });
    var v = item.querySelector('video'); if (!v) return;
    var on = !item.classList.contains('is-sound');
    v.muted = !on; item.classList.toggle('is-sound', on);
    if (on) { v.currentTime = 0; tryPlay(v); }
  }
  sec.querySelectorAll('.czl-reel__item.is-video').forEach(function (item) {
    item.addEventListener('click', function () {
      if (item.classList.contains('is-blocked')) { var v = item.querySelector('video'); if (v) tryPlay(v); return; }
      setSound(item);
    });
  });

  /* explainer video: assets/cz-explainer.js (loaded by snippets/cz-explainer-video.liquid) */

  /* step animations run only while visible */
  sec.querySelectorAll('[data-czl-live]').forEach(function (el) {
    if (reduce) return;
    onView(el, function (vis) { el.classList.toggle('is-live', vis); if (el.hasAttribute('data-czl-size-anim')) sizeAnim(el, vis); }, { threshold: 0.25 });
  });

  /* step 2: the frame eases between sizes, the cm labels and the size pill follow (design 12 cm wide at 46 %) */
  function sizeAnim(el, run) {
    var box = el.querySelector('.czl-a2__box'), w = el.querySelector('.czl-a2__w'), h = el.querySelector('.czl-a2__h'), pills = el.querySelectorAll('.czl-a2__pills b');
    if (!run) { cancelAnimationFrame(el.__raf); el.__raf = 0; return; }
    if (el.__raf) return;
    var comma = /^de/i.test(document.documentElement.lang || '');
    var fmt = function (n) { var s = n.toFixed(1).replace(/\.0$/, ''); return comma ? s.replace('.', ',') : s; };
    var seq = [8, 12, 17, 12], t0 = performance.now(), seg = 1700, from = seq[0];
    function frameFn(now) {
      var t = (now - t0) / seg, i = Math.floor(t) % seq.length, f = t - Math.floor(t);
      var a = seq[i], b = seq[(i + 1) % seq.length], k = f < 0.45 ? 0 : (f - 0.45) / 0.55;
      k = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      var cm = a + (b - a) * k;
      box.style.width = (cm / 12 * 46).toFixed(2) + '%';
      w.textContent = fmt(cm) + ' cm';
      h.textContent = fmt(cm * 212 / 500) + ' cm';
      var idx = cm < 9 ? 0 : cm < 13 ? 1 : cm < 18 ? 2 : 3;
      pills.forEach(function (p, j) { p.classList.toggle('is-on', j === idx); });
      el.__raf = requestAnimationFrame(frameFn);
    }
    el.__raf = requestAnimationFrame(frameFn);
    void from;
  }

  /* Builder demo: tap a stamp in the tray, it flies onto its finger; after the set: "automatically in the right size" */
  var hand = sec.querySelector('[data-czl-hand]');
  if (hand && !reduce && hasIO && hand.animate) {
    var inks = [].slice.call(hand.querySelectorAll('.czl-hand__ink')), picks = [].slice.call(hand.querySelectorAll('.czl-hand__pick'));
    var tap = hand.querySelector('.czl-hand__tap'), done = hand.querySelector('.czl-hand__done');
    var live = false, timer = 0, step = 0;
    var wait = function (ms) { return new Promise(function (r) { timer = setTimeout(r, ms); }); };
    function rel(el) { var a = el.getBoundingClientRect(), b = hand.getBoundingClientRect(); return { x: a.left - b.left + a.width / 2, y: a.top - b.top + a.height / 2, w: a.width, h: a.height }; }
    function reset() {
      inks.forEach(function (i) { i.classList.remove('is-on'); });
      picks.forEach(function (p) { p.classList.remove('is-used', 'is-hit'); });
      done.classList.remove('is-on'); step = 0;
    }
    function one(i) {
      var p = picks[i], ink = inks[i], s = rel(p), d = rel(ink);
      var fw = ink.offsetWidth * (parseFloat(ink.getAttribute('data-s')) || 0.7);
      tap.style.left = s.x + 'px'; tap.style.top = s.y + 'px';
      tap.animate([{ opacity: 0, transform: 'scale(1.6)' }, { opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(.8)' }], { duration: 520, easing: 'ease-out' });
      p.classList.add('is-hit');
      return wait(240).then(function () {
        var fly = document.createElement('img');
        fly.src = p.querySelector('img').currentSrc || p.querySelector('img').src; fly.className = 'czl-hand__fly'; fly.alt = '';
        fly.style.width = fw + 'px'; fly.style.left = (d.x - fw / 2) + 'px'; fly.style.top = (d.y - fw / 2) + 'px';
        hand.appendChild(fly);
        var dx = s.x - d.x, dy = s.y - d.y, k = Math.max(0.4, p.offsetWidth * 0.7 / fw);
        var an = fly.animate([
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + k + ')', filter: 'invert(1)', opacity: 1 },
          { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 40) + 'px) scale(1.3)', filter: 'invert(1)', opacity: 1, offset: 0.55 },
          { transform: 'translate(0,0) scale(1)', filter: 'invert(0)', opacity: 0.85 }
        ], { duration: 680, easing: 'cubic-bezier(.3,.7,.2,1)' });
        return new Promise(function (r) { an.onfinish = r; an.oncancel = r; }).then(function () {
          ink.classList.add('is-on'); p.classList.remove('is-hit'); p.classList.add('is-used');
          fly.animate([{ opacity: 0.85 }, { opacity: 0 }], { duration: 380, easing: 'ease-out' }).onfinish = function () { fly.remove(); };
        });
      });
    }
    function loop() {
      if (!live) return;
      if (step < inks.length) { one(step).then(function () { step++; return wait(240); }).then(loop); return; }
      done.classList.add('is-on');
      wait(2600).then(function () { if (!live) return; reset(); return wait(700); }).then(loop);
    }
    onView(hand, function (vis) {
      if (vis && !live) { live = true; reset(); wait(500).then(loop); }
      else if (!vis && live) { live = false; clearTimeout(timer); }
    }, { threshold: 0.45 });
  }

  /* typed AI prompt */
  var typed = sec.querySelector('[data-czl-type]');
  if (typed) {
    var full = typed.getAttribute('data-czl-type');
    if (reduce || !hasIO) typed.textContent = full;
    else {
      var tt = 0, running = false;
      var type = function (i) { typed.textContent = full.slice(0, i); if (!running) return; tt = setTimeout(function () { type(i < full.length ? i + 1 : 0); }, i < full.length ? 38 : 2600); };
      onView(typed, function (vis) { if (vis && !running) { running = true; type(0); } else if (!vis) { running = false; clearTimeout(tt); } }, { threshold: 0.6 });
    }
  }

  /* rail arrows at the left / right edge of the rail, vertically centred on the photos (same as .plpb-nav on
     home / collection), one card per click, hidden at the start / end (W12) */
  function railArrows(nav, rail, reduce) {
    var wrap = nav.parentNode, prev = nav.querySelector('[data-dir="-1"]'), next = nav.querySelector('[data-dir="1"]'), raf = 0;
    var update = function () {
      raf = 0;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      nav.hidden = max <= 0;
      var m = rail.querySelector('.czl-rev__img, .czl-reel__media') || rail.querySelector('li');
      if (m) { var mb = m.getBoundingClientRect(), wb = wrap.getBoundingClientRect(); if (mb.height) wrap.style.setProperty('--czl-arrow-y', Math.round(mb.top - wb.top + mb.height / 2) + 'px'); }
    };
    var soon = function () { if (!raf) raf = requestAnimationFrame(update); };
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dir]'); if (!btn) return;
      var item = rail.querySelector('li'), gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
      var stepW = item ? item.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      rail.scrollBy({ left: Number(btn.getAttribute('data-dir')) * stepW, behavior: reduce ? 'auto' : 'smooth' });
    });
    rail.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    if ('ResizeObserver' in window) new ResizeObserver(soon).observe(rail);
    update();
  }
  sec.querySelectorAll('[data-czl-nav]').forEach(function (nav) {
    var rail = sec.querySelector('[data-czl-rail="' + nav.getAttribute('data-czl-nav') + '"]');
    if (!rail) { nav.hidden = true; return; }
    railArrows(nav, rail, reduce);
  });
})();
